



















import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class WQtypeBigtextView extends BaseComponent {
	@Prop({ type: Object, required: true })
	options!: any;
	@Prop()
	injectedAnswer!: any;
	@Prop()
	injectedStats!: any;
	@Prop({ type: Boolean, default: false })
	lock!: boolean;

	answerValue = (this.injectedAnswer || { value: "" }).value;

	@Watch("answerValue")
	watchAwnswerValue() {
		this.onAnswerChange();
	}

	get stats() {
		if (this.injectedStats) {
			let total = this.injectedStats.questionAnswersCount,
				totalEmpty = this.injectedStats.questionAnswersEmptyCount,
				totalNoEmpty = total - totalEmpty,
				percent =
					parseInt(String((totalNoEmpty / (total || 1)) * 10000)) /
					100;

			return {
				total,
				totalEmpty,
				totalNoEmpty,
				percent
			};
		}
		return {};
	}

	get form() {
		let attrs: any = {
			autocomplete: "off",
			autofocus: true
		};

		attrs["minlength"] = this.options.min;

		if (this.options.max) {
			attrs["maxlength"] = this.options.max;
		}

		return {
			fields: {
				answer: {
					field: "textarea",
					i18n: { placeholder: "SX_LANG_WRITE" },
					attrs
				}
			}
		};
	}

	@Emit("type-answer-change")
	onAnswerChange() {
		let min = this.options.min,
			max = this.options.max,
			len = this.answerValue ? this.answerValue.length : 0,
			valid = true;

		if (len) {
			valid = min <= len && (max ? len <= max : true);
		}

		return {
			value: this.answerValue,
			isValid: valid,
			isEmpty: !len
		};
	}
	mounted() {
		this.onAnswerChange();
	}
}
